import React, { useEffect, useState } from "react";
import apiCompany from "../../../apis/company/apiCompany";
import AppAlert from "../../common/AppAlert";
import AppLoading from "../../common/AppLoading";
import BreadCrumb from "../../common/AppBreadCrumb";
import AppInput from "../../controls/AppInput";
import AppSelect from "../../controls/AppSelect";
import AppTitle from "../../controls/AppTitle";
import apiContractor from "../../../apis/contractor/apiContractor";

function ContractorEditScreen() {
	const [name, setName] = useState("");
	const [company, setCompany] = useState({});
	const [loading, setLoading] = useState(false);
	const [companyList, setCompanyList] = useState([]);
	const [errorsForm, setErrorsForm] = useState({});

	const CreateContractor = async () => {
		const contractor = {
			name: name,
			company_id: company.value,
		};

		setLoading(true);
		const response = await apiContractor.createContractor(contractor);
		setLoading(false);

		if (response.ok) {
			AppAlert.SimpleAlert(response.message);
			setErrorsForm({});
		} else {
			setErrorsForm(response);
		}
	};

	const GetCompanies = async () => {
		const response = await apiCompany.getCompaniesDropdown();

		if (response.ok) {
			setCompanyList(response.data);
		}
	};

	useEffect(() => {
		GetCompanies();
	}, []);

	return (
		<div className="row">
			<div className="col-12">
				<AppTitle text="Registro de Contratista" />
				<BreadCrumb items={[{ label: "Contratistas" }, { label: "Registro de Contratista", active: true }]} />
			</div>
			<div className="card col-12">
				<div className="row card-body col-12">
					<div className="col-6">
						<AppInput
							label="Nombre del Contratista"
							type="text"
							onChange={({ target }) => setName(target.value)}
							placeholder="Nombre del Contratista"
							errors={errorsForm.name}
						/>
					</div>
					<div className="col-6">
						<AppSelect label="Compañía" items={companyList} onChange={(dinner) => setCompany(dinner ? dinner : {})} errors={errorsForm.company_id} />
					</div>
					<div className="col-12 text-center my-4">
						<button className="btn btn-primary" onClick={CreateContractor}>
							Registrar Contratista
						</button>
					</div>
				</div>
			</div>
			<AppLoading visible={loading} />
		</div>
	);
}

export default ContractorEditScreen;
